import { render, staticRenderFns } from "./CompanyNews.vue?vue&type=template&id=925bc982&scoped=true"
import script from "./CompanyNews.vue?vue&type=script&lang=js"
export * from "./CompanyNews.vue?vue&type=script&lang=js"
import style0 from "./CompanyNews.vue?vue&type=style&index=0&id=925bc982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925bc982",
  null
  
)

export default component.exports